import Money from '../Moneys/Money';
import { Price } from '../../Models/Price';
export default class Packet {
    constructor(props) {
        this.prices = [];
        this.stretches = [];
        this.collaboratorStretches = [];
        // console.log('Packet - constructor - props: ', props)
        Object.assign(this, props);
        if (props === null || props === void 0 ? void 0 : props.primaryMoney) {
            this.primaryMoney = new Money(props.primaryMoney);
        }
    }
}
export class PacketPrice extends Price {
    constructor(values) {
        super(values);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Packets/Packet.ts
// module id = 92
// module chunks = 0